import { ordersHome, useCurrentMembership } from "@luckymenu/staff-core";
import { createFileRoute, Navigate } from "@tanstack/react-router";
import { OrdersBoard } from "../features/orders/orders-board";

export const Route = createFileRoute("/orders/")({ component: Page });

/** The live board; the kitchen opens its KOT list instead. */
function Page() {
	const current = useCurrentMembership();
	if (current.data && ordersHome(current.data.role) === "kitchen")
		return <Navigate to="/orders/kots" replace />;
	return <OrdersBoard />;
}
